<template>
    <div class="timeline p-10" :class="{'max-h-100': draggable}">
        <draggable v-model="list" v-bind="dragOptions" @change="syncDataForContractCheck">
                <div :class="['timeline-item', {'hover-effect': draggable } ]" v-for="(entry, index) in list" :key="index" :style="{ cursor: cursor }" @mouseover="onHover"
      @mouseleave="noHover">
                    <div style="z-index: 1;">
                      <svgicon :name="entry.type === 'pickup' ? 'pick-up-arrow' : 'drop-off-arrow'" width="14" height="14" :original="true" />
                    </div>
                    <div v-if="index < list.length - 1" class="line"></div>
                    <div class="content ml-20">
                    <div class="content-header">{{$t('TASK')}} {{ index + 1 }}: {{ entry.type === 'pickup' ? $t('INDENT_PICKUP') : $t('INDENT_DROPOFF') }}</div>
                    <div class="content-sub-header">{{ entry.name }}
                        <div class="sub-content">{{ entry.ref_id }}</div>
                    </div>
                    </div>
                </div>
        </draggable>
    </div>
</template>
<script>
import draggable from 'vuedraggable';

export default {
  name: 'PickupDropTimeline',
  components: {
    draggable,
  },
  data() {
    return {
      list: [],
      previousList: [],
      cursor: 'pointer',
    };
  },
  props: {
    pickupDrops: {
      type: Array,
      default: () => [],
    },
    draggable: {
      type: Boolean,
      default: () => false,
    },
    resetSequence: {
      type: Boolean,
      default: () => true
    },
    isOutbound: {
      type: Boolean,
      default: () => true,
    }
  },
  computed: {
    dragOptions() {
      return {
        disabled: !this.draggable,
        animation: 200,
      };
    },
  },
  watch: {
    pickupDrops(newVal) {
      this.list = [...newVal];
      if (this.resetSequence) {
        this.previousList = [...newVal];
        this.emitInitialSequence(newVal);
      }
    },
  },
  mounted() {
    this.list = [...this.pickupDrops];
    this.previousList = [...this.pickupDrops];
    if (this.resetSequence) {
      this.emitInitialSequence(this.list);
    }
  },
  methods: {
    onHover() {
      if (this.draggable) {
        this.cursor = 'move';
      }
    },
    noHover() {
      this.cursor = 'default';
    },
    emitInitialSequence(data) {
      this.$emit('set-initial-sequence', [...data]);
    },
    /**
     * Method to validate shuffled data and trigger contract-check
     */
    syncDataForContractCheck() {
      const listSize = this.list.length;
      let errorMsg = null;
      const firstPickupIsConsignee = this.list[0].isConsignee;
      const firstEntryIsDrop = this.list[0].type === 'drop';
      const lastEntryIsPickup = this.list[listSize - 1].type === 'pickup';
      if(this.isOutbound && firstPickupIsConsignee) {
        errorMsg = this.$t('INDENT_START_CANNOT_BE_CONSIGNEE');
      }
      if (firstEntryIsDrop) {
        errorMsg = this.$t('INDENT_START_CANNOT_BE_DROP');
      } else if (lastEntryIsPickup) {
        errorMsg = this.$t('INDENT_REACH_CANNOT_BE_PICKUP');
      }
      if (errorMsg) {
        this.$errorMessage({ message: errorMsg });
        this.resetList();
      } else {
        this.$emit('update-sequence', this.list);
      }
    },
    resetList() {
      this.list = [...this.previousList];
    },
    syncPreviousList() {
      this.previousList = [...this.list];
    },
  },
};
</script>

<style lang="scss" scoped>
  .max-h-100 {
    max-height: 100% !important;
  }
  .timeline {
    display: flex;
    flex-direction: column;
    max-height: 400px;
    overflow-y: auto;
    overflow-x: hidden;
    .hover-effect {
      &:hover {
        background: #48484850;
        box-shadow: 0px 2px 14px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
      }
    }
    .timeline-item {
      position: relative;
      display: flex;
      .dot, .dot1 {
        width: 15px;
        height: 15px;
        border-radius: 50%;
        position: relative;
        z-index: 1;
        .arrow-tl, .arrow-br {
          font-size: 13px;
          position: absolute;
          top: 1px;
          color: #000000;
          left: 2px;
        }
      }
      .dot {
        background-color: #1FCD93;
      }
      .dot1 {
        background-color: #FFEEC4;
        .arrow-br {
          top: 0px;
        }
      }
      .line {
        width: 2px;
        flex-grow: 1;
        position: absolute;
        top: 8px;
        bottom: 0;
        left: 7px;
        border-left: 1px dashed #ffffff40;
      }
      .content {
        padding: 0 10px 10px;
        border-radius: 5px;
        &-header {
          color: #8A8A9E;
          font-size: 12px;
          font-weight: 400;
          margin-bottom: 5px;
        }
        &-sub-header {
          color: #D5DAF4;
          font-weight: 700;
          font-size: 12px;
          .sub-content {
            position: relative;
            left: 170px;
            top: -13px;
            font-size: 10px;
            font-weight: 400;
            color: #8A8A9E;
          }
        }
      }
    }
  }
</style>
